import { AdminComponent } from '~/components/admin-component/admin-component';

export const MembershipTypes = () => (
  <AdminComponent
    componentName="MembershipTypes"
    title="Memebership Types"
  />
);
